import { type ChangeEvent } from 'react';
import { useLanguage } from '@/hooks/useLanguage';
import styles from './BrandHeader.module.scss';

interface Props {
  handleSearchChange: (e: ChangeEvent<HTMLInputElement>) => void;
  searchTerm: string;
  searchPlaceholder: string;
}

export const SearchInput = ({ handleSearchChange, searchTerm, searchPlaceholder }: Props) => {
  const { isRTL } = useLanguage();
  return (
    <div className={styles.searchContainer}>
      <div className={styles.searchWrapper}>
        <input
          type="text"
          placeholder={searchPlaceholder}
          onChange={handleSearchChange}
          value={searchTerm}
          className={styles.searchInput}
          dir={isRTL ? 'rtl' : 'ltr'}
          data-testid="brand-search-input"
        />
      </div>
    </div>
  );
};
